import { render } from "./ContactanosView.vue?vue&type=template&id=9ec7259c"
import script from "./ContactanosView.vue?vue&type=script&lang=js"
export * from "./ContactanosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__